import {Record} from 'immutable';
import {ReduceStore} from 'flux/utils';
import ActionTypes from '../ActionTypes';
import AppDispatcher from '../AppDispatcher';
import _ from 'lodash';

const State = new Record({
    events: [],
    selectedEvent: null,
    centers: null,
    fortalezaId: null,
});

function getEventById(events, id) {
    if (!id) return null;

    return _.find(events, function (course) {
        return course.id === id;
    });
}

function getSelectedEvent(events) {
    if (!events)
        return null;

    return _.find(events, function (event) {
        return event.selected;
    });
}

function getFortalezaId(centers) {
    let id = null;

    centers.forEach(function (item) {
        if (id !== null)
            return;

        let name = _.toLower(item.name);
        let idx = name.indexOf('fortaleza');

        if (idx > -1)
            id = item.id;
    });

    return id;
}

class ParticipantesStore extends ReduceStore {
    constructor() {
        super(AppDispatcher);
    }

    getInitialState() {
        return new State();
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.UPDATE_TOKEN_FAILED:
            case ActionTypes.LOGOUT:
                return state.clear();

            case ActionTypes.SELECT_EVENT_FOR_PARTICIPANTS:
                return state.set('selectedEvent', getEventById(state.events, action.eventId));

            case ActionTypes.SELECT_EVENTS_FINISH:
                return state
                    .set('events', action.events)
                    .set('selectedEvent', getSelectedEvent(action.events));

            case ActionTypes.SELECT_CENTERS_FINISH:
                return state
                    .set('centers', action.centers)
                    .set('fortalezaId', getFortalezaId(action.centers));

            default:
                return state;
        }
    }
}

export default new ParticipantesStore();



// WEBPACK FOOTER //
// src/stores/ParticipantesStore.js